module.exports = __webpack_public_path__ + "img/sudbury_b1.86ee5a8f.jpg";